import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Logo from "../../assets/images/41be3761-ca81-4794-ade8-22f6692f9894_logo-redondo.webp";

function Header() {
  const [open, setOpen] = useState(false);
  const [hidden, setHidden] = useState(false);
  const lastScrollY = useRef(0);

  const links = [
    { label: "Início",      href: "#inicio" },
    { label: "Serviços",    href: "#servicos" },
    { label: "Sobre",       href: "#sobre" },
    { label: "Depoimentos", href: "#depoimentos" },
    { label: "Planos",      href: "#planos" },
    { label: "Contato",     href: "#contato" },
  ];

  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;

      // Rolando para baixo e já passou de uma margem → esconde
      if (currentY > lastScrollY.current && currentY > 80) {
        setHidden(true);
        setOpen(false); // fecha o menu mobile ao esconder
      } else {
        // Rolando para cima → mostra
        setHidden(false);
      }

      lastScrollY.current = currentY;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 bg-black backdrop-blur border-b border-neutral-800 transition-transform duration-300 ease-in-out ${
        hidden ? "-translate-y-full" : "translate-y-0"
      }`}
    >
      <div className="container mx- lg:px-28 lg:max-w-full  px-6 flex items-center justify-between h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3" onClick={() => setOpen(false)}>
          <img className="w-12 h-12 object-contain" src={Logo} alt="Thiago Vieira" />
        </Link>

        {/* Nav desktop */}
        {/* <nav className="hidden md:flex items-center gap-8"> */}
        <nav className="hidden">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm text-neutral-200 hover:text-gold-500 transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        {/* CTA desktop */}
        <a
          href="#contato"
          className="hidden"
          // className="hidden md:inline-flex items-center px-5 py-2.5 rounded-md bg-gold-500 text-background font-semibold text-sm hover:bg-gold-400 transition-colors"
        >
          Agendar avaliação
        </a>

        {/* Botão hambúrguer (mobile) */}
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? "Fechar menu" : "Abrir menu"}
          aria-expanded={open}
          className="hidden"
          // className="md:hidden flex items-center justify-center w-10 h-10 text-neutral-100"
        >
          {open ? (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          ) : (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="3" y1="6" x2="21" y2="6" />
              <line x1="3" y1="12" x2="21" y2="12" />
              <line x1="3" y1="18" x2="21" y2="18" />
            </svg>
          )}
        </button>
      </div>

      {/* Painel mobile */}
      <div
        className={`md:hidden overflow-hidden border-t border-neutral-800 bg-black transition-[max-height] duration-300 ease-in-out ${
          open ? "max-h-96" : "max-h-0"
        }`}
      >
        <nav className="flex flex-col px-6 py-4 gap-1">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="py-3 text-sm text-neutral-200 hover:text-gold-500 transition-colors border-b border-neutral-900 last:border-b-0"
            >
              {l.label}
            </a>
          ))}

          <a
            href="#contato"
            onClick={() => setOpen(false)}
            className="mt-3 inline-flex items-center justify-center px-5 py-3 rounded-md bg-gold-500 text-background font-semibold text-sm hover:bg-gold-400 transition-colors"
          >
            Agendar avaliação
          </a>
        </nav>
      </div>
    </header>
  );
}

export default Header;
